module.exports = __webpack_public_path__ + "static/media/icon-team-survey-progress-in-progress.dae8b1d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-team-survey-progress-in-progress.svg
// module id = 1853
// module chunks = 0